<template>
    <v-dialog v-model="value" scrollable persistent :max-width="800" non-linear>
        <v-card>
            <v-card-title class="primary modal-title">
                <span>Resposta {{ tipo }}</span>
                <v-spacer/>
                <v-btn icon @click="fecharModal">
                    <v-icon size="20" color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12 sm6>
                        <div class="az-text">
                            <label>Data Resposta</label>
                            <p>{{ item.data }}</p>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <div class="az-text">
                            <label>Anexo</label>
                            <p v-if="item.anexo">
                                <a class="az-action-link-icon" target="_blank"
                                   @click.prevent="downloadAnexo(item.anexo)">
                                    Baixar Anexo
                                    <v-icon size="20px">mdi-download</v-icon>
                                </a>
                            </p>
                            <span v-else>--</span>
                        </div>
                    </v-flex>

                    <v-flex xs12>
                        <div class="az-text">
                            <label>Conteúdo</label>
                            <p>{{ item.mensagem }}</p>
                        </div>
                    </v-flex>
                </v-layout>

                <div v-if="item.respostaComplementar.id">
                    <v-flex xs12 sm12 d-flex>
                        <span class="subtitle-reposta">Resposta Complementar</span>
                    </v-flex>

                    <v-layout wrap>
                        <v-flex xs12 sm6>
                            <div class="az-text">
                                <label>Data Resposta Complementar</label>
                                <p>{{ item.respostaComplementar.data }}</p>
                            </div>
                        </v-flex>

                        <v-flex xs12 sm6>
                            <div class="az-text">
                                <label>Anexo</label>
                                <p v-if="item.respostaComplementar.anexo">
                                    <a class="az-action-link-icon" target="_blank"
                                       @click.prevent="downloadAnexo(item.respostaComplementar.anexo)">
                                        Baixar Anexo
                                        <v-icon size="20px">mdi-download</v-icon>
                                    </a>
                                </p>
                                <span v-else>--</span>
                            </div>
                        </v-flex>

                        <v-flex xs12>
                            <div class="az-text">
                                <label>Conteúdo</label>
                                <p>{{ item.respostaComplementar.mensagem }}</p>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="fecharModal">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalRespostasEsclarecimentoImpugnacao',
    props: {
        value: Boolean,
        item: {
            type: Object
        },
        tipo: {
            type: String
        }
    },
    methods: {
        downloadAnexo(anexo) {
            this.$emit('downloadAnexo', anexo)
        },
        fecharModal() {
            this.$emit('fecharModalRespostas')
        },
    }
};
</script>

<style scoped>
.az-text label {
    font-weight: bold;
    display: block;
    margin-bottom: 4px;
}

.az-action-link-icon {
    color: blue;
    text-decoration: none;
}

.subtitle-reposta {
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0;
    border-bottom: 1px solid;
}
</style>